export default import.meta.ROLLDOWN_FILE_URL_nMga7jihVSyK103YfUNlOQ